import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    asideShow: false,
    darkMode: true,
    role: '',
    userCount: 5
};

export const storeData = Vue.observable({
    walletBalance: '0',
    walletAddress: '',
    companyDetails: [],
    employeeDetails: []
});

export const getStoreFromLocalStorage = () => {
    for (const el in storeData) {
        storeData[el] = JSON.parse(localStorage.getItem(el));
        localStorage.removeItem(el);
    }
};

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
        state.sidebarShow = sidebarOpened ? false : 'responsive';
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
        state.sidebarShow = sidebarClosed ? true : 'responsive';
    },
    set(state, [variable, value]) {
        state[variable] = value;
    },
    toggle(state, variable) {
        state[variable] = !state[variable];
    }
};

export default new Vuex.Store({
    state,
    mutations
});
